/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface ServicePlanTemplatesService {
  /**
   * @summary Get All
   * @description Gets all service plan templates for the current office.
   */
  getAllServicePlanTemplatesGet: {
    /**
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetAllServicePlanTemplatesGetSchema,
            GetAllServicePlanTemplatesGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<GetAllServicePlanTemplatesGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetAllServicePlanTemplatesGetSchema,
        options: {
          parameters: GetAllServicePlanTemplatesGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetAllServicePlanTemplatesGetData, GetAllServicePlanTemplatesGetError>>
    ): Promise<RequestFnResponse<GetAllServicePlanTemplatesGetData, GetAllServicePlanTemplatesGetError>>;
    /**
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     */
    getQueryKey(
      parameters: DeepReadonly<GetAllServicePlanTemplatesGetParameters> | void
    ): ServiceOperationQueryKey<GetAllServicePlanTemplatesGetSchema, GetAllServicePlanTemplatesGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.servicePlanTemplatesService.getAllServicePlanTemplatesGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllServicePlanTemplatesGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllServicePlanTemplatesGetSchema, GetAllServicePlanTemplatesGetParameters>
        | (DeepReadonly<GetAllServicePlanTemplatesGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetAllServicePlanTemplatesGetData,
          GetAllServicePlanTemplatesGetError,
          TData,
          ServiceOperationQueryKey<GetAllServicePlanTemplatesGetSchema, GetAllServicePlanTemplatesGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetAllServicePlanTemplatesGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.servicePlanTemplatesService.getAllServicePlanTemplatesGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllServicePlanTemplatesGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllServicePlanTemplatesGetSchema, GetAllServicePlanTemplatesGetParameters>
        | (DeepReadonly<GetAllServicePlanTemplatesGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetAllServicePlanTemplatesGetData,
          GetAllServicePlanTemplatesGetError,
          TData,
          ServiceOperationQueryKey<GetAllServicePlanTemplatesGetSchema, GetAllServicePlanTemplatesGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetAllServicePlanTemplatesGetError>>;
    /**
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetAllServicePlanTemplatesGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<GetAllServicePlanTemplatesGetSchema, GetAllServicePlanTemplatesGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.servicePlanTemplatesService.getAllServicePlanTemplatesGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllServicePlanTemplatesGetParameters,
      TQueryFnData = GetAllServicePlanTemplatesGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllServicePlanTemplatesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllServicePlanTemplatesGetSchema, GetAllServicePlanTemplatesGetParameters>
        | (DeepReadonly<GetAllServicePlanTemplatesGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllServicePlanTemplatesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetAllServicePlanTemplatesGetSchema,
            GetAllServicePlanTemplatesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetAllServicePlanTemplatesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.servicePlanTemplatesService.getAllServicePlanTemplatesGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllServicePlanTemplatesGetParameters,
      TQueryFnData = GetAllServicePlanTemplatesGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllServicePlanTemplatesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllServicePlanTemplatesGetSchema, GetAllServicePlanTemplatesGetParameters>
        | (DeepReadonly<GetAllServicePlanTemplatesGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllServicePlanTemplatesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetAllServicePlanTemplatesGetSchema,
            GetAllServicePlanTemplatesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllServicePlanTemplatesGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetAllServicePlanTemplatesGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getAllServicePlanTemplatesGetTotal = qraft.servicePlanTemplatesService.getAllServicePlanTemplatesGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServicePlanTemplatesGetSchema,
            GetAllServicePlanTemplatesGetData,
            TInfinite,
            GetAllServicePlanTemplatesGetParameters,
            GetAllServicePlanTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServicePlanTemplatesGetSchema,
            GetAllServicePlanTemplatesGetData,
            TInfinite,
            GetAllServicePlanTemplatesGetParameters,
            GetAllServicePlanTemplatesGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getAllServicePlanTemplatesGetResults = qraft.servicePlanTemplatesService.getAllServicePlanTemplatesGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllServicePlanTemplatesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getAllServicePlanTemplatesGetCombinedResults = qraft.servicePlanTemplatesService.getAllServicePlanTemplatesGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllServicePlanTemplatesGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetAllServicePlanTemplatesGetSchema,
          GetAllServicePlanTemplatesGetParameters,
          GetAllServicePlanTemplatesGetData,
          GetAllServicePlanTemplatesGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetAllServicePlanTemplatesGetData, GetAllServicePlanTemplatesGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<GetAllServicePlanTemplatesGetData, GetAllServicePlanTemplatesGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.servicePlanTemplatesService.getAllServicePlanTemplatesGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = GetAllServicePlanTemplatesGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllServicePlanTemplatesGetSchema, GetAllServicePlanTemplatesGetParameters>
        | (DeepReadonly<GetAllServicePlanTemplatesGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetAllServicePlanTemplatesGetData,
          GetAllServicePlanTemplatesGetError,
          TData,
          ServiceOperationQueryKey<GetAllServicePlanTemplatesGetSchema, GetAllServicePlanTemplatesGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetAllServicePlanTemplatesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.servicePlanTemplatesService.getAllServicePlanTemplatesGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetAllServicePlanTemplatesGetParameters,
      TData = GetAllServicePlanTemplatesGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllServicePlanTemplatesGetSchema, GetAllServicePlanTemplatesGetParameters>
        | (DeepReadonly<GetAllServicePlanTemplatesGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetAllServicePlanTemplatesGetData,
          GetAllServicePlanTemplatesGetError,
          OperationInfiniteData<TData, GetAllServicePlanTemplatesGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetAllServicePlanTemplatesGetSchema,
            GetAllServicePlanTemplatesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllServicePlanTemplatesGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetAllServicePlanTemplatesGetParameters>,
      OperationError<GetAllServicePlanTemplatesGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getAllServicePlanTemplatesGetData = qraft.servicePlanTemplatesService.getAllServicePlanTemplatesGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllServicePlanTemplatesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getAllServicePlanTemplatesGetCombinedData = qraft.servicePlanTemplatesService.getAllServicePlanTemplatesGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllServicePlanTemplatesGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetAllServicePlanTemplatesGetSchema,
          GetAllServicePlanTemplatesGetParameters,
          GetAllServicePlanTemplatesGetData,
          GetAllServicePlanTemplatesGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<GetAllServicePlanTemplatesGetData, GetAllServicePlanTemplatesGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<GetAllServicePlanTemplatesGetData, GetAllServicePlanTemplatesGetError>,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllServicePlanTemplatesGetSchema,
        GetAllServicePlanTemplatesGetData,
        GetAllServicePlanTemplatesGetParameters,
        GetAllServicePlanTemplatesGetError
      > | void
    ): Promise<GetAllServicePlanTemplatesGetData>;
    /**
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllServicePlanTemplatesGetSchema,
        GetAllServicePlanTemplatesGetData,
        GetAllServicePlanTemplatesGetParameters,
        GetAllServicePlanTemplatesGetError
      > | void
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetAllServicePlanTemplatesGetSchema,
        GetAllServicePlanTemplatesGetData,
        GetAllServicePlanTemplatesGetParameters,
        GetAllServicePlanTemplatesGetError
      > | void
    ): Promise<GetAllServicePlanTemplatesGetData>;
    /**
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     */
    fetchInfiniteQuery<TPageParam extends GetAllServicePlanTemplatesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllServicePlanTemplatesGetSchema,
        GetAllServicePlanTemplatesGetData,
        GetAllServicePlanTemplatesGetParameters,
        DeepReadonly<TPageParam>,
        GetAllServicePlanTemplatesGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllServicePlanTemplatesGetData, GetAllServicePlanTemplatesGetParameters>>;
    /**
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     */
    prefetchInfiniteQuery<TPageParam extends GetAllServicePlanTemplatesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllServicePlanTemplatesGetSchema,
        GetAllServicePlanTemplatesGetData,
        GetAllServicePlanTemplatesGetParameters,
        DeepReadonly<TPageParam>,
        GetAllServicePlanTemplatesGetError
      > | void
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     */
    ensureInfiniteQueryData<TPageParam extends GetAllServicePlanTemplatesGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetAllServicePlanTemplatesGetSchema,
        GetAllServicePlanTemplatesGetData,
        GetAllServicePlanTemplatesGetParameters,
        DeepReadonly<TPageParam>,
        GetAllServicePlanTemplatesGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllServicePlanTemplatesGetData, GetAllServicePlanTemplatesGetParameters>>;
    /**
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetAllServicePlanTemplatesGetSchema, GetAllServicePlanTemplatesGetParameters>
        | (DeepReadonly<GetAllServicePlanTemplatesGetParameters> | void)
    ): GetAllServicePlanTemplatesGetData | undefined;
    /**
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllServicePlanTemplatesGetSchema, GetAllServicePlanTemplatesGetParameters>
        | (DeepReadonly<GetAllServicePlanTemplatesGetParameters> | void)
    ): OperationInfiniteData<GetAllServicePlanTemplatesGetData, GetAllServicePlanTemplatesGetParameters> | undefined;
    /**
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServicePlanTemplatesGetSchema,
            GetAllServicePlanTemplatesGetData,
            TInfinite,
            GetAllServicePlanTemplatesGetParameters,
            GetAllServicePlanTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServicePlanTemplatesGetSchema,
            GetAllServicePlanTemplatesGetData,
            TInfinite,
            GetAllServicePlanTemplatesGetParameters,
            GetAllServicePlanTemplatesGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetAllServicePlanTemplatesGetSchema,
              GetAllServicePlanTemplatesGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<GetAllServicePlanTemplatesGetData, GetAllServicePlanTemplatesGetParameters>
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetAllServicePlanTemplatesGetSchema,
              GetAllServicePlanTemplatesGetParameters
            >,
            data: GetAllServicePlanTemplatesGetData | undefined,
          ]
        >;
    /**
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetAllServicePlanTemplatesGetSchema, GetAllServicePlanTemplatesGetParameters>
        | (DeepReadonly<GetAllServicePlanTemplatesGetParameters> | void)
    ): QueryState<GetAllServicePlanTemplatesGetData, GetAllServicePlanTemplatesGetError> | undefined;
    /**
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetAllServicePlanTemplatesGetParameters>
        | ServiceOperationInfiniteQueryKey<GetAllServicePlanTemplatesGetSchema, GetAllServicePlanTemplatesGetParameters>
        | void
    ):
      | QueryState<
          OperationInfiniteData<GetAllServicePlanTemplatesGetData, GetAllServicePlanTemplatesGetParameters>,
          GetAllServicePlanTemplatesGetError
        >
      | undefined;
    /**
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     */
    setQueryData(
      parameters:
        | (DeepReadonly<GetAllServicePlanTemplatesGetParameters> | undefined)
        | ServiceOperationQueryKey<GetAllServicePlanTemplatesGetSchema, GetAllServicePlanTemplatesGetParameters>,
      updater: Updater<
        NoInfer<GetAllServicePlanTemplatesGetData> | undefined,
        NoInfer<DeepReadonly<GetAllServicePlanTemplatesGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetAllServicePlanTemplatesGetData | undefined;
    /**
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetAllServicePlanTemplatesGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<
            GetAllServicePlanTemplatesGetSchema,
            GetAllServicePlanTemplatesGetParameters
          >,
      updater: Updater<
        | NoInfer<OperationInfiniteData<GetAllServicePlanTemplatesGetData, GetAllServicePlanTemplatesGetParameters>>
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<GetAllServicePlanTemplatesGetData, GetAllServicePlanTemplatesGetParameters>
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetAllServicePlanTemplatesGetData, GetAllServicePlanTemplatesGetParameters> | undefined;
    /**
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetAllServicePlanTemplatesGetSchema,
            GetAllServicePlanTemplatesGetData,
            TInfinite,
            GetAllServicePlanTemplatesGetParameters,
            GetAllServicePlanTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServicePlanTemplatesGetSchema,
            GetAllServicePlanTemplatesGetData,
            TInfinite,
            GetAllServicePlanTemplatesGetParameters,
            GetAllServicePlanTemplatesGetError
          >,
      updater: Updater<
        NoInfer<GetAllServicePlanTemplatesGetData> | undefined,
        NoInfer<GetAllServicePlanTemplatesGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetAllServicePlanTemplatesGetData | undefined>;
    /**
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetAllServicePlanTemplatesGetSchema,
        GetAllServicePlanTemplatesGetData,
        TInfinite,
        GetAllServicePlanTemplatesGetParameters,
        GetAllServicePlanTemplatesGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServicePlanTemplatesGetSchema,
            GetAllServicePlanTemplatesGetData,
            TInfinite,
            GetAllServicePlanTemplatesGetParameters,
            GetAllServicePlanTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServicePlanTemplatesGetSchema,
            GetAllServicePlanTemplatesGetData,
            TInfinite,
            GetAllServicePlanTemplatesGetParameters,
            GetAllServicePlanTemplatesGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServicePlanTemplatesGetSchema,
            GetAllServicePlanTemplatesGetData,
            TInfinite,
            GetAllServicePlanTemplatesGetParameters,
            GetAllServicePlanTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServicePlanTemplatesGetSchema,
            GetAllServicePlanTemplatesGetData,
            TInfinite,
            GetAllServicePlanTemplatesGetParameters,
            GetAllServicePlanTemplatesGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServicePlanTemplatesGetSchema,
            GetAllServicePlanTemplatesGetData,
            TInfinite,
            GetAllServicePlanTemplatesGetParameters,
            GetAllServicePlanTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServicePlanTemplatesGetSchema,
            GetAllServicePlanTemplatesGetData,
            TInfinite,
            GetAllServicePlanTemplatesGetParameters,
            GetAllServicePlanTemplatesGetError
          >
    ): void;
    /**
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServicePlanTemplatesGetSchema,
            GetAllServicePlanTemplatesGetData,
            TInfinite,
            GetAllServicePlanTemplatesGetParameters,
            GetAllServicePlanTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServicePlanTemplatesGetSchema,
            GetAllServicePlanTemplatesGetData,
            TInfinite,
            GetAllServicePlanTemplatesGetParameters,
            GetAllServicePlanTemplatesGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Gets all service plan templates for the current office.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServicePlanTemplatesGetSchema,
            GetAllServicePlanTemplatesGetData,
            TInfinite,
            GetAllServicePlanTemplatesGetParameters,
            GetAllServicePlanTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServicePlanTemplatesGetSchema,
            GetAllServicePlanTemplatesGetData,
            TInfinite,
            GetAllServicePlanTemplatesGetParameters,
            GetAllServicePlanTemplatesGetError
          >
    ): number;
    schema: GetAllServicePlanTemplatesGetSchema;
    types: {
      parameters: GetAllServicePlanTemplatesGetParameters;
      data: GetAllServicePlanTemplatesGetData;
      error: GetAllServicePlanTemplatesGetError;
    };
  };
  /**
   * @summary Create
   * @description Creates a new service plan template.
   */
  createServicePlanTemplatesPost: {
    /**
     * @summary Create
     * @description Creates a new service plan template.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CreateServicePlanTemplatesPostBody,
        CreateServicePlanTemplatesPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CreateServicePlanTemplatesPostSchema,
        options: ServiceOperationMutationFnOptions<
          CreateServicePlanTemplatesPostBody,
          CreateServicePlanTemplatesPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<CreateServicePlanTemplatesPostData, CreateServicePlanTemplatesPostError>>
    ): Promise<RequestFnResponse<CreateServicePlanTemplatesPostData, CreateServicePlanTemplatesPostError>>;
    /**
     * @summary Create
     * @description Creates a new service plan template.
     */
    getMutationKey(
      parameters: DeepReadonly<CreateServicePlanTemplatesPostParameters> | void
    ): ServiceOperationMutationKey<CreateServicePlanTemplatesPostSchema, CreateServicePlanTemplatesPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @description Creates a new service plan template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.servicePlanTemplatesService.createServicePlanTemplatesPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.servicePlanTemplatesService.createServicePlanTemplatesPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateServicePlanTemplatesPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateServicePlanTemplatesPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateServicePlanTemplatesPostSchema,
        CreateServicePlanTemplatesPostData,
        CreateServicePlanTemplatesPostParameters,
        TVariables,
        OperationError<CreateServicePlanTemplatesPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateServicePlanTemplatesPostData,
      OperationError<CreateServicePlanTemplatesPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @description Creates a new service plan template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.servicePlanTemplatesService.createServicePlanTemplatesPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.servicePlanTemplatesService.createServicePlanTemplatesPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CreateServicePlanTemplatesPostBody,
        CreateServicePlanTemplatesPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateServicePlanTemplatesPostSchema,
        CreateServicePlanTemplatesPostData,
        CreateServicePlanTemplatesPostParameters,
        TVariables,
        OperationError<CreateServicePlanTemplatesPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateServicePlanTemplatesPostData,
      OperationError<CreateServicePlanTemplatesPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @description Creates a new service plan template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createServicePlanTemplatesPostTotal = qraft.servicePlanTemplatesService.createServicePlanTemplatesPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createServicePlanTemplatesPostTotal = qraft.servicePlanTemplatesService.createServicePlanTemplatesPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateServicePlanTemplatesPostBody,
            CreateServicePlanTemplatesPostData,
            CreateServicePlanTemplatesPostParameters,
            OperationError<CreateServicePlanTemplatesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateServicePlanTemplatesPostSchema,
            CreateServicePlanTemplatesPostBody,
            CreateServicePlanTemplatesPostData,
            CreateServicePlanTemplatesPostParameters,
            OperationError<CreateServicePlanTemplatesPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @description Creates a new service plan template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createServicePlanTemplatesPostPendingMutationVariables = qraft.servicePlanTemplatesService.createServicePlanTemplatesPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createServicePlanTemplatesPostMutationData = qraft.servicePlanTemplatesService.createServicePlanTemplatesPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateServicePlanTemplatesPostData,
        OperationError<CreateServicePlanTemplatesPostError>,
        MutationVariables<CreateServicePlanTemplatesPostBody, CreateServicePlanTemplatesPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateServicePlanTemplatesPostBody,
            CreateServicePlanTemplatesPostData,
            CreateServicePlanTemplatesPostParameters,
            OperationError<CreateServicePlanTemplatesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateServicePlanTemplatesPostSchema,
            CreateServicePlanTemplatesPostBody,
            CreateServicePlanTemplatesPostData,
            CreateServicePlanTemplatesPostParameters,
            OperationError<CreateServicePlanTemplatesPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateServicePlanTemplatesPostData,
          OperationError<CreateServicePlanTemplatesPostError>,
          MutationVariables<CreateServicePlanTemplatesPostBody, CreateServicePlanTemplatesPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Create
     * @description Creates a new service plan template.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateServicePlanTemplatesPostBody,
            CreateServicePlanTemplatesPostData,
            CreateServicePlanTemplatesPostParameters,
            OperationError<CreateServicePlanTemplatesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateServicePlanTemplatesPostSchema,
            CreateServicePlanTemplatesPostBody,
            CreateServicePlanTemplatesPostData,
            CreateServicePlanTemplatesPostParameters,
            OperationError<CreateServicePlanTemplatesPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @description Creates a new service plan template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.servicePlanTemplatesService.createServicePlanTemplatesPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.servicePlanTemplatesService.createServicePlanTemplatesPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateServicePlanTemplatesPostBody,
              CreateServicePlanTemplatesPostData,
              CreateServicePlanTemplatesPostParameters,
              OperationError<CreateServicePlanTemplatesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateServicePlanTemplatesPostSchema,
              CreateServicePlanTemplatesPostBody,
              CreateServicePlanTemplatesPostData,
              CreateServicePlanTemplatesPostParameters,
              OperationError<CreateServicePlanTemplatesPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateServicePlanTemplatesPostData,
            CreateServicePlanTemplatesPostError,
            MutationVariables<CreateServicePlanTemplatesPostBody, CreateServicePlanTemplatesPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateServicePlanTemplatesPostBody,
              CreateServicePlanTemplatesPostData,
              CreateServicePlanTemplatesPostParameters,
              OperationError<CreateServicePlanTemplatesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateServicePlanTemplatesPostSchema,
              CreateServicePlanTemplatesPostBody,
              CreateServicePlanTemplatesPostData,
              CreateServicePlanTemplatesPostParameters,
              OperationError<CreateServicePlanTemplatesPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateServicePlanTemplatesPostData,
          CreateServicePlanTemplatesPostError,
          MutationVariables<CreateServicePlanTemplatesPostBody, CreateServicePlanTemplatesPostParameters>,
          TContext
        >
      >;
    };
    schema: CreateServicePlanTemplatesPostSchema;
    types: {
      parameters: CreateServicePlanTemplatesPostParameters;
      data: CreateServicePlanTemplatesPostData;
      error: CreateServicePlanTemplatesPostError;
      body: CreateServicePlanTemplatesPostBody;
    };
  };
  /**
   * @summary Get
   * @description Gets a service plan template by ID.
   */
  getServicePlanTemplatesTemplateIdGet: {
    /**
     * @summary Get
     * @description Gets a service plan template by ID.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<GetServicePlanTemplatesTemplateIdGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetServicePlanTemplatesTemplateIdGetSchema,
        options: {
          parameters: GetServicePlanTemplatesTemplateIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<GetServicePlanTemplatesTemplateIdGetData, GetServicePlanTemplatesTemplateIdGetError>
      >
    ): Promise<RequestFnResponse<GetServicePlanTemplatesTemplateIdGetData, GetServicePlanTemplatesTemplateIdGetError>>;
    /**
     * @summary Get
     * @description Gets a service plan template by ID.
     */
    getQueryKey(
      parameters: DeepReadonly<GetServicePlanTemplatesTemplateIdGetParameters>
    ): ServiceOperationQueryKey<
      GetServicePlanTemplatesTemplateIdGetSchema,
      GetServicePlanTemplatesTemplateIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @description Gets a service plan template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.servicePlanTemplatesService.getServicePlanTemplatesTemplateIdGet.useQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetServicePlanTemplatesTemplateIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetServicePlanTemplatesTemplateIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetServicePlanTemplatesTemplateIdGetData,
          GetServicePlanTemplatesTemplateIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetServicePlanTemplatesTemplateIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @description Gets a service plan template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.servicePlanTemplatesService.getServicePlanTemplatesTemplateIdGet.useQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetServicePlanTemplatesTemplateIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetServicePlanTemplatesTemplateIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetServicePlanTemplatesTemplateIdGetData,
          GetServicePlanTemplatesTemplateIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetServicePlanTemplatesTemplateIdGetError>>;
    /**
     * @summary Get
     * @description Gets a service plan template by ID.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetServicePlanTemplatesTemplateIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetServicePlanTemplatesTemplateIdGetSchema,
      GetServicePlanTemplatesTemplateIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @description Gets a service plan template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.servicePlanTemplatesService.getServicePlanTemplatesTemplateIdGet.useInfiniteQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetServicePlanTemplatesTemplateIdGetParameters,
      TQueryFnData = GetServicePlanTemplatesTemplateIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetServicePlanTemplatesTemplateIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetServicePlanTemplatesTemplateIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetServicePlanTemplatesTemplateIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetServicePlanTemplatesTemplateIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @description Gets a service plan template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.servicePlanTemplatesService.getServicePlanTemplatesTemplateIdGet.useInfiniteQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetServicePlanTemplatesTemplateIdGetParameters,
      TQueryFnData = GetServicePlanTemplatesTemplateIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetServicePlanTemplatesTemplateIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetServicePlanTemplatesTemplateIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetServicePlanTemplatesTemplateIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetServicePlanTemplatesTemplateIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetServicePlanTemplatesTemplateIdGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get
     * @description Gets a service plan template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getServicePlanTemplatesTemplateIdGetTotal = qraft.servicePlanTemplatesService.getServicePlanTemplatesTemplateIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getServicePlanTemplatesTemplateIdGetByParametersTotal = qraft.servicePlanTemplatesService.getServicePlanTemplatesTemplateIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             template_id: templateId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetData,
            TInfinite,
            GetServicePlanTemplatesTemplateIdGetParameters,
            GetServicePlanTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetData,
            TInfinite,
            GetServicePlanTemplatesTemplateIdGetParameters,
            GetServicePlanTemplatesTemplateIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get
     * @description Gets a service plan template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getServicePlanTemplatesTemplateIdGetResults = qraft.servicePlanTemplatesService.getServicePlanTemplatesTemplateIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 template_id: templateId1
     *             }
     *         },
     *         {
     *             path: {
     *                 template_id: templateId2
     *             }
     *         }
     *     ]
     * });
     * getServicePlanTemplatesTemplateIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getServicePlanTemplatesTemplateIdGetCombinedResults = qraft.servicePlanTemplatesService.getServicePlanTemplatesTemplateIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 template_id: templateId1
     *             }
     *         },
     *         {
     *             path: {
     *                 template_id: templateId2
     *             }
     *         }
     *     ]
     * });
     * getServicePlanTemplatesTemplateIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetServicePlanTemplatesTemplateIdGetSchema,
          GetServicePlanTemplatesTemplateIdGetParameters,
          GetServicePlanTemplatesTemplateIdGetData,
          GetServicePlanTemplatesTemplateIdGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<GetServicePlanTemplatesTemplateIdGetData, GetServicePlanTemplatesTemplateIdGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<GetServicePlanTemplatesTemplateIdGetData, GetServicePlanTemplatesTemplateIdGetError>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @description Gets a service plan template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.servicePlanTemplatesService.getServicePlanTemplatesTemplateIdGet.useSuspenseQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetServicePlanTemplatesTemplateIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetServicePlanTemplatesTemplateIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetServicePlanTemplatesTemplateIdGetData,
          GetServicePlanTemplatesTemplateIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetServicePlanTemplatesTemplateIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get
     * @description Gets a service plan template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.servicePlanTemplatesService.getServicePlanTemplatesTemplateIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetServicePlanTemplatesTemplateIdGetParameters,
      TData = GetServicePlanTemplatesTemplateIdGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetServicePlanTemplatesTemplateIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetServicePlanTemplatesTemplateIdGetData,
          GetServicePlanTemplatesTemplateIdGetError,
          OperationInfiniteData<TData, GetServicePlanTemplatesTemplateIdGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetServicePlanTemplatesTemplateIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetServicePlanTemplatesTemplateIdGetParameters>,
      OperationError<GetServicePlanTemplatesTemplateIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @description Gets a service plan template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getServicePlanTemplatesTemplateIdGetData = qraft.servicePlanTemplatesService.getServicePlanTemplatesTemplateIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 template_id: templateId1
     *             }
     *         },
     *         {
     *             path: {
     *                 template_id: templateId2
     *             }
     *         }
     *     ]
     * });
     * getServicePlanTemplatesTemplateIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getServicePlanTemplatesTemplateIdGetCombinedData = qraft.servicePlanTemplatesService.getServicePlanTemplatesTemplateIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 template_id: templateId1
     *             }
     *         },
     *         {
     *             path: {
     *                 template_id: templateId2
     *             }
     *         }
     *     ]
     * });
     * getServicePlanTemplatesTemplateIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetServicePlanTemplatesTemplateIdGetSchema,
          GetServicePlanTemplatesTemplateIdGetParameters,
          GetServicePlanTemplatesTemplateIdGetData,
          GetServicePlanTemplatesTemplateIdGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<GetServicePlanTemplatesTemplateIdGetData, GetServicePlanTemplatesTemplateIdGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<GetServicePlanTemplatesTemplateIdGetData, GetServicePlanTemplatesTemplateIdGetError>,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get
     * @description Gets a service plan template by ID.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetServicePlanTemplatesTemplateIdGetSchema,
        GetServicePlanTemplatesTemplateIdGetData,
        GetServicePlanTemplatesTemplateIdGetParameters,
        GetServicePlanTemplatesTemplateIdGetError
      >
    ): Promise<GetServicePlanTemplatesTemplateIdGetData>;
    /**
     * @summary Get
     * @description Gets a service plan template by ID.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetServicePlanTemplatesTemplateIdGetSchema,
        GetServicePlanTemplatesTemplateIdGetData,
        GetServicePlanTemplatesTemplateIdGetParameters,
        GetServicePlanTemplatesTemplateIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get
     * @description Gets a service plan template by ID.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetServicePlanTemplatesTemplateIdGetSchema,
        GetServicePlanTemplatesTemplateIdGetData,
        GetServicePlanTemplatesTemplateIdGetParameters,
        GetServicePlanTemplatesTemplateIdGetError
      >
    ): Promise<GetServicePlanTemplatesTemplateIdGetData>;
    /**
     * @summary Get
     * @description Gets a service plan template by ID.
     */
    fetchInfiniteQuery<TPageParam extends GetServicePlanTemplatesTemplateIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetServicePlanTemplatesTemplateIdGetSchema,
        GetServicePlanTemplatesTemplateIdGetData,
        GetServicePlanTemplatesTemplateIdGetParameters,
        DeepReadonly<TPageParam>,
        GetServicePlanTemplatesTemplateIdGetError
      >
    ): Promise<
      OperationInfiniteData<GetServicePlanTemplatesTemplateIdGetData, GetServicePlanTemplatesTemplateIdGetParameters>
    >;
    /**
     * @summary Get
     * @description Gets a service plan template by ID.
     */
    prefetchInfiniteQuery<TPageParam extends GetServicePlanTemplatesTemplateIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetServicePlanTemplatesTemplateIdGetSchema,
        GetServicePlanTemplatesTemplateIdGetData,
        GetServicePlanTemplatesTemplateIdGetParameters,
        DeepReadonly<TPageParam>,
        GetServicePlanTemplatesTemplateIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get
     * @description Gets a service plan template by ID.
     */
    ensureInfiniteQueryData<TPageParam extends GetServicePlanTemplatesTemplateIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetServicePlanTemplatesTemplateIdGetSchema,
        GetServicePlanTemplatesTemplateIdGetData,
        GetServicePlanTemplatesTemplateIdGetParameters,
        DeepReadonly<TPageParam>,
        GetServicePlanTemplatesTemplateIdGetError
      >
    ): Promise<
      OperationInfiniteData<GetServicePlanTemplatesTemplateIdGetData, GetServicePlanTemplatesTemplateIdGetParameters>
    >;
    /**
     * @summary Get
     * @description Gets a service plan template by ID.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetServicePlanTemplatesTemplateIdGetParameters>
    ): GetServicePlanTemplatesTemplateIdGetData | undefined;
    /**
     * @summary Get
     * @description Gets a service plan template by ID.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetServicePlanTemplatesTemplateIdGetParameters>
    ):
      | OperationInfiniteData<GetServicePlanTemplatesTemplateIdGetData, GetServicePlanTemplatesTemplateIdGetParameters>
      | undefined;
    /**
     * @summary Get
     * @description Gets a service plan template by ID.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetData,
            TInfinite,
            GetServicePlanTemplatesTemplateIdGetParameters,
            GetServicePlanTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetData,
            TInfinite,
            GetServicePlanTemplatesTemplateIdGetParameters,
            GetServicePlanTemplatesTemplateIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetServicePlanTemplatesTemplateIdGetSchema,
              GetServicePlanTemplatesTemplateIdGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetServicePlanTemplatesTemplateIdGetData,
                    GetServicePlanTemplatesTemplateIdGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetServicePlanTemplatesTemplateIdGetSchema,
              GetServicePlanTemplatesTemplateIdGetParameters
            >,
            data: GetServicePlanTemplatesTemplateIdGetData | undefined,
          ]
        >;
    /**
     * @summary Get
     * @description Gets a service plan template by ID.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetServicePlanTemplatesTemplateIdGetParameters>
    ): QueryState<GetServicePlanTemplatesTemplateIdGetData, GetServicePlanTemplatesTemplateIdGetError> | undefined;
    /**
     * @summary Get
     * @description Gets a service plan template by ID.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetServicePlanTemplatesTemplateIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetServicePlanTemplatesTemplateIdGetData,
            GetServicePlanTemplatesTemplateIdGetParameters
          >,
          GetServicePlanTemplatesTemplateIdGetError
        >
      | undefined;
    /**
     * @summary Get
     * @description Gets a service plan template by ID.
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetServicePlanTemplatesTemplateIdGetParameters>
        | ServiceOperationQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetParameters
          >,
      updater: Updater<
        NoInfer<GetServicePlanTemplatesTemplateIdGetData> | undefined,
        NoInfer<DeepReadonly<GetServicePlanTemplatesTemplateIdGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetServicePlanTemplatesTemplateIdGetData | undefined;
    /**
     * @summary Get
     * @description Gets a service plan template by ID.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetServicePlanTemplatesTemplateIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetServicePlanTemplatesTemplateIdGetData,
              GetServicePlanTemplatesTemplateIdGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetServicePlanTemplatesTemplateIdGetData,
                GetServicePlanTemplatesTemplateIdGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<GetServicePlanTemplatesTemplateIdGetData, GetServicePlanTemplatesTemplateIdGetParameters>
      | undefined;
    /**
     * @summary Get
     * @description Gets a service plan template by ID.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetData,
            TInfinite,
            GetServicePlanTemplatesTemplateIdGetParameters,
            GetServicePlanTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetData,
            TInfinite,
            GetServicePlanTemplatesTemplateIdGetParameters,
            GetServicePlanTemplatesTemplateIdGetError
          >,
      updater: Updater<
        NoInfer<GetServicePlanTemplatesTemplateIdGetData> | undefined,
        NoInfer<GetServicePlanTemplatesTemplateIdGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetServicePlanTemplatesTemplateIdGetData | undefined>;
    /**
     * @summary Get
     * @description Gets a service plan template by ID.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetServicePlanTemplatesTemplateIdGetSchema,
        GetServicePlanTemplatesTemplateIdGetData,
        TInfinite,
        GetServicePlanTemplatesTemplateIdGetParameters,
        GetServicePlanTemplatesTemplateIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get
     * @description Gets a service plan template by ID.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetData,
            TInfinite,
            GetServicePlanTemplatesTemplateIdGetParameters,
            GetServicePlanTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetData,
            TInfinite,
            GetServicePlanTemplatesTemplateIdGetParameters,
            GetServicePlanTemplatesTemplateIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get
     * @description Gets a service plan template by ID.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetData,
            TInfinite,
            GetServicePlanTemplatesTemplateIdGetParameters,
            GetServicePlanTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetData,
            TInfinite,
            GetServicePlanTemplatesTemplateIdGetParameters,
            GetServicePlanTemplatesTemplateIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get
     * @description Gets a service plan template by ID.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetData,
            TInfinite,
            GetServicePlanTemplatesTemplateIdGetParameters,
            GetServicePlanTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetData,
            TInfinite,
            GetServicePlanTemplatesTemplateIdGetParameters,
            GetServicePlanTemplatesTemplateIdGetError
          >
    ): void;
    /**
     * @summary Get
     * @description Gets a service plan template by ID.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetData,
            TInfinite,
            GetServicePlanTemplatesTemplateIdGetParameters,
            GetServicePlanTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetData,
            TInfinite,
            GetServicePlanTemplatesTemplateIdGetParameters,
            GetServicePlanTemplatesTemplateIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get
     * @description Gets a service plan template by ID.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetData,
            TInfinite,
            GetServicePlanTemplatesTemplateIdGetParameters,
            GetServicePlanTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetServicePlanTemplatesTemplateIdGetSchema,
            GetServicePlanTemplatesTemplateIdGetData,
            TInfinite,
            GetServicePlanTemplatesTemplateIdGetParameters,
            GetServicePlanTemplatesTemplateIdGetError
          >
    ): number;
    schema: GetServicePlanTemplatesTemplateIdGetSchema;
    types: {
      parameters: GetServicePlanTemplatesTemplateIdGetParameters;
      data: GetServicePlanTemplatesTemplateIdGetData;
      error: GetServicePlanTemplatesTemplateIdGetError;
    };
  };
  /**
   * @summary Update
   * @description Updates an existing service plan template.
   */
  updateServicePlanTemplatesTemplateIdPatch: {
    /**
     * @summary Update
     * @description Updates an existing service plan template.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateServicePlanTemplatesTemplateIdPatchBody,
        UpdateServicePlanTemplatesTemplateIdPatchParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateServicePlanTemplatesTemplateIdPatchSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateServicePlanTemplatesTemplateIdPatchBody,
          UpdateServicePlanTemplatesTemplateIdPatchParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<UpdateServicePlanTemplatesTemplateIdPatchData, UpdateServicePlanTemplatesTemplateIdPatchError>
      >
    ): Promise<
      RequestFnResponse<UpdateServicePlanTemplatesTemplateIdPatchData, UpdateServicePlanTemplatesTemplateIdPatchError>
    >;
    /**
     * @summary Update
     * @description Updates an existing service plan template.
     */
    getMutationKey(
      parameters: DeepReadonly<UpdateServicePlanTemplatesTemplateIdPatchParameters> | void
    ): ServiceOperationMutationKey<
      UpdateServicePlanTemplatesTemplateIdPatchSchema,
      UpdateServicePlanTemplatesTemplateIdPatchParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @description Updates an existing service plan template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.servicePlanTemplatesService.updateServicePlanTemplatesTemplateIdPatch.useMutation({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.servicePlanTemplatesService.updateServicePlanTemplatesTemplateIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         template_id: templateId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateServicePlanTemplatesTemplateIdPatchBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateServicePlanTemplatesTemplateIdPatchParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateServicePlanTemplatesTemplateIdPatchSchema,
        UpdateServicePlanTemplatesTemplateIdPatchData,
        UpdateServicePlanTemplatesTemplateIdPatchParameters,
        TVariables,
        OperationError<UpdateServicePlanTemplatesTemplateIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateServicePlanTemplatesTemplateIdPatchData,
      OperationError<UpdateServicePlanTemplatesTemplateIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @description Updates an existing service plan template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.servicePlanTemplatesService.updateServicePlanTemplatesTemplateIdPatch.useMutation({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.servicePlanTemplatesService.updateServicePlanTemplatesTemplateIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         template_id: templateId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        UpdateServicePlanTemplatesTemplateIdPatchBody,
        UpdateServicePlanTemplatesTemplateIdPatchParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateServicePlanTemplatesTemplateIdPatchSchema,
        UpdateServicePlanTemplatesTemplateIdPatchData,
        UpdateServicePlanTemplatesTemplateIdPatchParameters,
        TVariables,
        OperationError<UpdateServicePlanTemplatesTemplateIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateServicePlanTemplatesTemplateIdPatchData,
      OperationError<UpdateServicePlanTemplatesTemplateIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @description Updates an existing service plan template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateServicePlanTemplatesTemplateIdPatchTotal = qraft.servicePlanTemplatesService.updateServicePlanTemplatesTemplateIdPatch.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateServicePlanTemplatesTemplateIdPatchTotal = qraft.servicePlanTemplatesService.updateServicePlanTemplatesTemplateIdPatch.useIsMutating({
     *     parameters: {
     *         path: {
     *             template_id: templateId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateServicePlanTemplatesTemplateIdPatchBody,
            UpdateServicePlanTemplatesTemplateIdPatchData,
            UpdateServicePlanTemplatesTemplateIdPatchParameters,
            OperationError<UpdateServicePlanTemplatesTemplateIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateServicePlanTemplatesTemplateIdPatchSchema,
            UpdateServicePlanTemplatesTemplateIdPatchBody,
            UpdateServicePlanTemplatesTemplateIdPatchData,
            UpdateServicePlanTemplatesTemplateIdPatchParameters,
            OperationError<UpdateServicePlanTemplatesTemplateIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @description Updates an existing service plan template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateServicePlanTemplatesTemplateIdPatchPendingMutationVariables = qraft.servicePlanTemplatesService.updateServicePlanTemplatesTemplateIdPatch.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateServicePlanTemplatesTemplateIdPatchMutationData = qraft.servicePlanTemplatesService.updateServicePlanTemplatesTemplateIdPatch.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 template_id: templateId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateServicePlanTemplatesTemplateIdPatchData,
        OperationError<UpdateServicePlanTemplatesTemplateIdPatchError>,
        MutationVariables<
          UpdateServicePlanTemplatesTemplateIdPatchBody,
          UpdateServicePlanTemplatesTemplateIdPatchParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateServicePlanTemplatesTemplateIdPatchBody,
            UpdateServicePlanTemplatesTemplateIdPatchData,
            UpdateServicePlanTemplatesTemplateIdPatchParameters,
            OperationError<UpdateServicePlanTemplatesTemplateIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateServicePlanTemplatesTemplateIdPatchSchema,
            UpdateServicePlanTemplatesTemplateIdPatchBody,
            UpdateServicePlanTemplatesTemplateIdPatchData,
            UpdateServicePlanTemplatesTemplateIdPatchParameters,
            OperationError<UpdateServicePlanTemplatesTemplateIdPatchError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateServicePlanTemplatesTemplateIdPatchData,
          OperationError<UpdateServicePlanTemplatesTemplateIdPatchError>,
          MutationVariables<
            UpdateServicePlanTemplatesTemplateIdPatchBody,
            UpdateServicePlanTemplatesTemplateIdPatchParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Update
     * @description Updates an existing service plan template.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateServicePlanTemplatesTemplateIdPatchBody,
            UpdateServicePlanTemplatesTemplateIdPatchData,
            UpdateServicePlanTemplatesTemplateIdPatchParameters,
            OperationError<UpdateServicePlanTemplatesTemplateIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateServicePlanTemplatesTemplateIdPatchSchema,
            UpdateServicePlanTemplatesTemplateIdPatchBody,
            UpdateServicePlanTemplatesTemplateIdPatchData,
            UpdateServicePlanTemplatesTemplateIdPatchParameters,
            OperationError<UpdateServicePlanTemplatesTemplateIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @description Updates an existing service plan template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.servicePlanTemplatesService.updateServicePlanTemplatesTemplateIdPatch.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             template_id: templateId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.servicePlanTemplatesService.updateServicePlanTemplatesTemplateIdPatch.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateServicePlanTemplatesTemplateIdPatchBody,
              UpdateServicePlanTemplatesTemplateIdPatchData,
              UpdateServicePlanTemplatesTemplateIdPatchParameters,
              OperationError<UpdateServicePlanTemplatesTemplateIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateServicePlanTemplatesTemplateIdPatchSchema,
              UpdateServicePlanTemplatesTemplateIdPatchBody,
              UpdateServicePlanTemplatesTemplateIdPatchData,
              UpdateServicePlanTemplatesTemplateIdPatchParameters,
              OperationError<UpdateServicePlanTemplatesTemplateIdPatchError>,
              TContext
            >
      ):
        | Mutation<
            UpdateServicePlanTemplatesTemplateIdPatchData,
            UpdateServicePlanTemplatesTemplateIdPatchError,
            MutationVariables<
              UpdateServicePlanTemplatesTemplateIdPatchBody,
              UpdateServicePlanTemplatesTemplateIdPatchParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateServicePlanTemplatesTemplateIdPatchBody,
              UpdateServicePlanTemplatesTemplateIdPatchData,
              UpdateServicePlanTemplatesTemplateIdPatchParameters,
              OperationError<UpdateServicePlanTemplatesTemplateIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateServicePlanTemplatesTemplateIdPatchSchema,
              UpdateServicePlanTemplatesTemplateIdPatchBody,
              UpdateServicePlanTemplatesTemplateIdPatchData,
              UpdateServicePlanTemplatesTemplateIdPatchParameters,
              OperationError<UpdateServicePlanTemplatesTemplateIdPatchError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateServicePlanTemplatesTemplateIdPatchData,
          UpdateServicePlanTemplatesTemplateIdPatchError,
          MutationVariables<
            UpdateServicePlanTemplatesTemplateIdPatchBody,
            UpdateServicePlanTemplatesTemplateIdPatchParameters
          >,
          TContext
        >
      >;
    };
    schema: UpdateServicePlanTemplatesTemplateIdPatchSchema;
    types: {
      parameters: UpdateServicePlanTemplatesTemplateIdPatchParameters;
      data: UpdateServicePlanTemplatesTemplateIdPatchData;
      error: UpdateServicePlanTemplatesTemplateIdPatchError;
      body: UpdateServicePlanTemplatesTemplateIdPatchBody;
    };
  };
}
/**
 * @summary Get All
 * @description Gets all service plan templates for the current office.
 */
export const getAllServicePlanTemplatesGet = {
  schema: {
    method: 'get',
    url: '/service_plan_templates',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetAllServicePlanTemplatesGetSchema;
  [QraftServiceOperationsToken]: ServicePlanTemplatesService['getAllServicePlanTemplatesGet'];
};
/**
 * @summary Create
 * @description Creates a new service plan template.
 */
export const createServicePlanTemplatesPost = {
  schema: {
    method: 'post',
    url: '/service_plan_templates',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateServicePlanTemplatesPostSchema;
  [QraftServiceOperationsToken]: ServicePlanTemplatesService['createServicePlanTemplatesPost'];
};
/**
 * @summary Get
 * @description Gets a service plan template by ID.
 */
export const getServicePlanTemplatesTemplateIdGet = {
  schema: {
    method: 'get',
    url: '/service_plan_templates/{template_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetServicePlanTemplatesTemplateIdGetSchema;
  [QraftServiceOperationsToken]: ServicePlanTemplatesService['getServicePlanTemplatesTemplateIdGet'];
};
/**
 * @summary Update
 * @description Updates an existing service plan template.
 */
export const updateServicePlanTemplatesTemplateIdPatch = {
  schema: {
    method: 'patch',
    url: '/service_plan_templates/{template_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateServicePlanTemplatesTemplateIdPatchSchema;
  [QraftServiceOperationsToken]: ServicePlanTemplatesService['updateServicePlanTemplatesTemplateIdPatch'];
};
export const servicePlanTemplatesService = {
  getAllServicePlanTemplatesGet,
  createServicePlanTemplatesPost,
  getServicePlanTemplatesTemplateIdGet,
  updateServicePlanTemplatesTemplateIdPatch,
} as const;
type GetAllServicePlanTemplatesGetSchema = {
  method: 'get';
  url: '/service_plan_templates';
  security: ['HTTPBearer'];
};
type GetAllServicePlanTemplatesGetParameters = undefined;
type GetAllServicePlanTemplatesGetData =
  paths['/service_plan_templates']['get']['responses']['200']['content']['application/json'];
type GetAllServicePlanTemplatesGetError = unknown;
type CreateServicePlanTemplatesPostSchema = {
  method: 'post';
  url: '/service_plan_templates';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateServicePlanTemplatesPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateServicePlanTemplatesPostData =
  paths['/service_plan_templates']['post']['responses']['201']['content']['application/json'];
type CreateServicePlanTemplatesPostError =
  paths['/service_plan_templates']['post']['responses']['422']['content']['application/json'];
type CreateServicePlanTemplatesPostBody =
  paths['/service_plan_templates']['post']['requestBody']['content']['application/json'];
type GetServicePlanTemplatesTemplateIdGetSchema = {
  method: 'get';
  url: '/service_plan_templates/{template_id}';
  security: ['HTTPBearer'];
};
type GetServicePlanTemplatesTemplateIdGetParameters =
  paths['/service_plan_templates/{template_id}']['get']['parameters'];
type GetServicePlanTemplatesTemplateIdGetData =
  paths['/service_plan_templates/{template_id}']['get']['responses']['200']['content']['application/json'];
type GetServicePlanTemplatesTemplateIdGetError =
  paths['/service_plan_templates/{template_id}']['get']['responses']['422']['content']['application/json'];
type UpdateServicePlanTemplatesTemplateIdPatchSchema = {
  method: 'patch';
  url: '/service_plan_templates/{template_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateServicePlanTemplatesTemplateIdPatchParameters =
  paths['/service_plan_templates/{template_id}']['patch']['parameters'];
type UpdateServicePlanTemplatesTemplateIdPatchData =
  paths['/service_plan_templates/{template_id}']['patch']['responses']['200']['content']['application/json'];
type UpdateServicePlanTemplatesTemplateIdPatchError =
  paths['/service_plan_templates/{template_id}']['patch']['responses']['422']['content']['application/json'];
type UpdateServicePlanTemplatesTemplateIdPatchBody =
  paths['/service_plan_templates/{template_id}']['patch']['requestBody']['content']['application/json'];
